import React, { useRef } from 'react';
import {
  AppBar,
  Card,
  CardContent,
  Toolbar,
  Tabs,
  Tab,
  Typography,
  IconButton,
  Drawer,
  Grid2 as Grid,
  DialogContent,
  Divider,
  DialogActions,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import FormCustomer from '../forms/FormCustomer';
import {
  Actions,
  useDispatchProvider,
  useStateDrawerCustomer,
  useStateFormCustomer,
  useStateTabsCustomer,
  useStateUser,
} from '../utils/StateProvider';
import ListCustomerOrders from '../lists/ListCustomerOrders';
import { usePermissions } from '../utils/AclProvider';
import ListCustomerTransactions from '../lists/ListCustomerTransactions';

const DrawerCustomer = () => {
  const portalRef = useRef(null);
  const permissions = usePermissions();
  const stateFormCustomer = useStateFormCustomer();
  const stateUser = useStateUser();
  const stateTabsCustomer = useStateTabsCustomer();
  const stateDrawerCustomer = useStateDrawerCustomer();
  const dispatch = useDispatchProvider();
  const handleDrawerClose = () => {
    dispatch && dispatch({ type: Actions.DrawerCustomer, payload: false });
  };

  const handleChangeTab = (event, newValue) => {
    dispatch && dispatch({ type: Actions.TabsCustomer, payload: newValue });
  };

  return (
    <>
      <Drawer
        className={'MuiDrawer-Customer'}
        open={stateDrawerCustomer}
        onClose={handleDrawerClose}
        anchor={'bottom'}
        color={'background'}
        elevation={0}
        sx={{
          '& .MuiDrawer-paper': {
            height: '100dvh',
          },
        }}
      >
        <AppBar position={'sticky'}>
          <Toolbar>
            <IconButton
              autoFocus
              size="large"
              edge="start"
              color="inherit"
              aria-label="close"
              sx={{ mr: 2 }}
              onClick={handleDrawerClose}
            >
              <Close />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              Customer details
            </Typography>
          </Toolbar>
        </AppBar>
        <AppBar
          elevation={0}
          position={'sticky'}
          color={'transparent'}
        >
          <Toolbar>
            <Tabs
              value={stateTabsCustomer}
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
            >
              <Tab
                label="Information"
                value="form"
                sx={{ height: 64 }}
              />
              <Tab
                label="Orders"
                value="orders"
                sx={{ height: 64 }}
                disabled={stateFormCustomer === ''}
              />
              {permissions?.transactions?.read && stateUser.security && (
                <Tab
                  label="Τransactions"
                  value="transactions"
                  sx={{ height: 64 }}
                />
              )}
            </Tabs>
          </Toolbar>
          <Divider />
        </AppBar>
        {stateTabsCustomer === 'form' && (
          <DialogContent>
            <Card elevation={1}>
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid size={{ xs: 12, md: 6 }}>
                    <FormCustomer portalRef={portalRef} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </DialogContent>
        )}
        {stateTabsCustomer === 'orders' && (
          <DialogContent sx={{ overflow: 'hidden', pb: 0 }}>
            <ListCustomerOrders />
          </DialogContent>
        )}
        {stateTabsCustomer === 'transactions' && (
          <DialogContent sx={{ overflow: 'hidden', pb: 0 }}>
            <ListCustomerTransactions portalRef={portalRef} />
          </DialogContent>
        )}
        <Divider />
        <DialogActions
          sx={{ paddingX: 3, paddingY: 2 }}
          ref={portalRef}
        />
      </Drawer>
    </>
  );
};

export default DrawerCustomer;
